import { useEffect, useRef, useState } from "react";
import { CalendarDays } from "lucide-react";

export const toFrDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return y && m && d ? `${d}/${m}/${y}` : "";
};

export const toIsoDate = (fr) => {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(fr || "");
  if (!m) return null;
  const [, d, mo, y] = m;
  const dt = new Date(Number(y), Number(mo) - 1, Number(d));
  if (dt.getFullYear() !== Number(y) || dt.getMonth() !== Number(mo) - 1 || dt.getDate() !== Number(d)) return null;
  return `${y}-${mo}-${d}`;
};

export default function DateInput({ value, onChange, required = false, ...rest }) {
  const testid = rest["data-testid"];
  const [text, setText] = useState(() => toFrDate(value));
  const hiddenRef = useRef(null);

  useEffect(() => {
    const iso = toIsoDate(text);
    if ((iso || "") !== (value || "")) setText(toFrDate(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const emit = (iso) => onChange({ target: { value: iso } });

  const handleText = (e) => {
    const digits = e.target.value.replace(/[^\d]/g, "").slice(0, 8);
    let v = digits;
    if (digits.length > 4) v = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
    else if (digits.length > 2) v = `${digits.slice(0, 2)}/${digits.slice(2)}`;
    setText(v);
    if (v === "") emit("");
    else if (v.length === 10) {
      const iso = toIsoDate(v);
      if (iso) emit(iso);
    }
  };

  const openPicker = () => {
    const el = hiddenRef.current;
    if (!el) return;
    el.value = value || "";
    try {
      if (el.showPicker) el.showPicker();
      else el.click();
    } catch {
      el.focus();
    }
  };

  return (
    <div className="relative">
      <input
        type="text"
        inputMode="numeric"
        data-testid={testid}
        value={text}
        onChange={handleText}
        onBlur={() => {
          if (text && !toIsoDate(text)) setText(toFrDate(value));
        }}
        placeholder="JJ/MM/AAAA"
        required={required}
        pattern="\d{2}/\d{2}/\d{4}"
        className="field-input pr-10"
      />
      <button
        type="button"
        onClick={openPicker}
        aria-label="Ouvrir le calendrier"
        data-testid={testid ? `${testid}-picker` : undefined}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-maquis-soft transition-colors duration-200 hover:text-maquis-deep"
      >
        <CalendarDays size={16} strokeWidth={1.5} />
      </button>
      <input
        type="date"
        ref={hiddenRef}
        tabIndex={-1}
        aria-hidden="true"
        className="pointer-events-none absolute bottom-0 right-0 h-px w-px opacity-0"
        onChange={(e) => emit(e.target.value)}
      />
    </div>
  );
}
